import React, { createContext, useContext } from 'react';
import { useAuth } from './context/AuthContext';
import { patchCompany } from './api/company/company';

const CompanyContext = createContext();

export const useCompany = () => useContext(CompanyContext);

export const CompanyProvider = ({ children }) => {
  const { user, companyData, updateCompanyData, loading } = useAuth();
  const companyId = companyData?.id || user?.companyId || null;
  const companyName = companyData?.name || 'Your Company Here';

  const updateCompanyName = async (newName) => {
    if (!companyId) return;
    try {
      const company = await patchCompany({
        companyId,
        company: { name: newName },
      });
      updateCompanyData?.({ ...(companyData || {}), ...company, name: newName });
    } catch (error) {
      console.error('Error updating company name:', error);
    }
  };

  return (
    <CompanyContext.Provider
      value={{
        companyName,
        updateCompanyName,
        companyId,
        companyData,
        loading,
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
};
